import PropTypes from "prop-types";
import {useEffect, useMemo} from "react";
import {setLocale} from "common/actions/locale";
import {createNotification} from "common/actions/notifications";
import Submit from "common/components/partials/form/submit";
import Divider from "common/components/partials/modal/divider";
import useAppContext from "common/hooks/use-app-context";
import useI18n from "common/hooks/use-i18n";
import Locale from "common/lib/locale";
import useSWRMutation from "swr/mutation";

function SelectLocale({closeModal, nextStep}) {
  const {current: {account, organization, profile, user}, dispatch, locale} = useAppContext();
  const i18n = useI18n();
  const originalLocale = useMemo(() => {
    let userLocale;

    if(organization.locales.length > 1) {
      let code = profile.primary_language;
      if(!code) { code = account.locale; }
      if(code) { userLocale = Locale.fromUser(code); }
      if(userLocale && !organization.locales.find((l) => l.code === userLocale.code)) {
        userLocale = null;
      }
    } else {
      userLocale = organization.default_locale;
    }

    return userLocale;
  }, []);
  const {isLoading: loading, trigger} = useSWRMutation({
    method: "PUT",
    url: "/api/public/account"
  }, {
    onSuccess: ({errors, success}) => {
      if(success) { return nextStep(); }

      dispatch(createNotification({content: errors, type: "error"}));
      closeModal();
    }
  });

  useEffect(() => {
    dispatch(setLocale(originalLocale || organization.default_locale));

    if(originalLocale) { nextStep(); }
  }, [originalLocale]);

  const onLocaleChange = ({target: {value}}) => {
    const newLocale = organization.locales.find(({code}) => code === value);

    newLocale && dispatch(setLocale(newLocale));
  };
  const onSubmit = (e) => {
    e.preventDefault();

    trigger({
      params: {
        account: {
          locale: locale.code,
          users_attributes: [{
            id: user.id,
            profile_attributes: {
              primary_language: locale.code
            }
          }]
        }
      }
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <section>
        <label htmlFor="assessment-locale">{i18n.t("assessment.preferred_language")}</label>
        <select className="p-form-field" id="assessment-locale" onChange={onLocaleChange} value={locale.code}>
          {organization.locales.map(({code, name}) => (
            <option key={code} value={code}>{name}</option>
          ))}
        </select>
      </section>
      <Divider />
      <section className="text-right">
        <Submit className="btn-theme" disabled={loading}>{i18n.t("submit")}</Submit>
      </section>
    </form>
  );
}

SelectLocale.propTypes = {
  closeModal: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired
};

export default SelectLocale;
